/**
 * Deep Link Initializer Component
 * Must be rendered inside BrowserRouter to access navigation
 */

import { useDeepLinkHandler } from '@/hooks/useDeepLinkHandler';

export function DeepLinkInitializer() {
  useDeepLinkHandler();
  return null;
}
